import { useState } from "react";
import { Play, X } from "lucide-react";
import { GlowButton } from "@/components/ui/GlowButton";

interface WatchDemoButtonProps {
  size?: "sm" | "md" | "lg";
  variant?: "primary" | "secondary" | "ghost";
  label?: string;
}

/**
 * "Watch demo video" CTA — opens a lightweight modal that plays the product-tour
 * video (public/demo.mp4, ~2 min, voiced: connect a repo → analysis → investor
 * report). Self-contained so it can drop in wherever the CTA appears without a
 * shared modal provider.
 */
export const WatchDemoButton = ({
  size = "lg",
  variant = "primary",
  label = "Watch demo video",
}: WatchDemoButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <GlowButton size={size} variant={variant} onClick={() => setOpen(true)}>
        <Play className="h-5 w-5" />
        {label}
      </GlowButton>

      {open && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
          onClick={() => setOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Product demo video"
        >
          <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setOpen(false)}
              className="absolute -top-10 right-0 text-white/80 transition-colors hover:text-white"
              aria-label="Close video"
            >
              <X className="h-6 w-6" />
            </button>
            <video
              src="/demo.mp4"
              poster="/demo-poster.jpg"
              controls
              autoPlay
              playsInline
              className="w-full rounded-xl border border-white/10 shadow-2xl"
            />
          </div>
        </div>
      )}
    </>
  );
};
